// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"83":"investment","136":"tradeWithUs","177":"home","454":"markets","809":"joinUs","943":"platforms"}[chunkId] + "." + {"83":"a0bb2dc2","136":"7d3938c8","177":"5b13b160","454":"15e8321a","809":"b9e01a8c","943":"17083a03"}[chunkId] + ".js";
};